import React, { Component } from "react";

class VitalsLegend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      descriptions: {
        LCP: "Largest Contentful Paint – loading speed. Target: < 2.5s",
        FID: "First Input Delay – interaction responsiveness. Target: < 100ms",
        INP: "Interaction to Next Paint – overall responsiveness. Target: < 200ms",
        CLS: "Cumulative Layout Shift – visual stability. Target: < 0.1",
        TTFB: "Time to First Byte – server response time. Target: < 600ms",
        FCP: "First Contentful Paint – first text/image. Target: < 1.8s",
      },
      colors: {
        Good: "#2e7d32",
        "Needs Improvement": "#f9a825",
        Poor: "#d32f2f",
      },
    };
  }

  render() {
    const { descriptions, colors } = this.state;

    return (
      <div className="mb-4" style={{ fontFamily: "Kumbh Sans" }}>
        <h5 className="mb-3" style={{ fontWeight: 600 }}>
          📘 Web Vitals Explained
        </h5>

        <div className="mb-3">
          {Object.keys(descriptions).map((metric) => (
            <div key={metric} style={{ marginBottom: "8px" }}>
              <strong>{metric}:</strong>{" "}
              <span style={{ fontSize: "0.95rem" }}>
                {descriptions[metric]}
              </span>
            </div>
          ))}
        </div>

        <div className="d-flex gap-3 mt-3 flex-wrap">
          {Object.keys(colors).map((rating) => (
            <div
              key={rating}
              className="d-flex align-items-center"
              style={{ fontSize: "0.9rem" }}
            >
              <div
                style={{
                  width: "14px",
                  height: "14px",
                  backgroundColor: colors[rating],
                  borderRadius: "3px",
                  marginRight: "6px",
                }}
              ></div>
              {rating}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default VitalsLegend;
